import { useTranslation } from 'react-i18next';

import { theme } from '@adflow/frontend/ui-theme';
import type { DataTableItemType } from '@adflow/shared/util-column-templates';

interface ListPaginationTotalProps {
	totalItems?: number;
	itemType?: DataTableItemType;
	sidebarView?: boolean;
	className?: string;
}

export function ListPaginationTotal(props: ListPaginationTotalProps) {
	const { totalItems, itemType, sidebarView, className } = props;

	const { t } = useTranslation();
	return (
		<p
			css={{
				marginRight: '1rem',
				fontWeight: '400',
				color: sidebarView
					? theme.colors.text.secondary
					: theme.colors.text.primary,
				marginBottom: 4,
				marginTop: 4,
				whiteSpace: 'nowrap',
			}}
			className={className}
		>
			{totalItems === undefined
				? t('pagination.loading')
				: t(`pagination.${itemType || 'item'}`, { count: totalItems })}
		</p>
	);
}
